import { render, staticRenderFns } from "./StatisticsMarksTimeFacultyView.vue?vue&type=template&id=ec2142ca"
import script from "./StatisticsMarksTimeFacultyView.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksTimeFacultyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports